import { getResourceUserButtons, deleteResourceUserButton } from "../../Utils/utils";
import ButtonPage from "./ButtonPage";

const UserButtons = () => (
    <ButtonPage
        idKey="resource_user_id"
        getListApi={getResourceUserButtons}
        deleteApi={deleteResourceUserButton}
    />
);

export default UserButtons;
